/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { systemComparisonControllerPostSystemComparison } from '../fn/system-comparison-controller/system-comparison-controller-post-system-comparison';
import { SystemComparisonControllerPostSystemComparison$Params } from '../fn/system-comparison-controller/system-comparison-controller-post-system-comparison';
import { SystemComparisonResponse } from '../models/system-comparison-response';


/**
 * API resource for system comparison endpoint.
 */
@Injectable({ providedIn: 'root' })
export class SystemComparisonControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `systemComparisonControllerPostSystemComparison()` */
  static readonly SystemComparisonControllerPostSystemComparisonPath = '/planning-projects/v2/system/comparison/{id}';

  /**
   * Returns the system comparison for a project.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `systemComparisonControllerPostSystemComparison()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemComparisonControllerPostSystemComparison$Response(params: SystemComparisonControllerPostSystemComparison$Params, context?: HttpContext): Observable<StrictHttpResponse<SystemComparisonResponse>> {
    return systemComparisonControllerPostSystemComparison(this.http, this.rootUrl, params, context);
  }

  /**
   * Returns the system comparison for a project.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `systemComparisonControllerPostSystemComparison$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  systemComparisonControllerPostSystemComparison(params: SystemComparisonControllerPostSystemComparison$Params, context?: HttpContext): Observable<SystemComparisonResponse> {
    return this.systemComparisonControllerPostSystemComparison$Response(params, context).pipe(
      map((r: StrictHttpResponse<SystemComparisonResponse>): SystemComparisonResponse => r.body)
    );
  }

}
